export default class BuyersEntity {
    constructor (data) {
        return data;
    }

}